import axios from "axios";

const api = axios.create({
    baseURL: "https://certificado-backend.vercel.app/certificados/"

});

export default api;